import axios from "axios";
import { createGenericErrorObject } from "../../utils/common";
import { fabricLicense } from "../../apis/apiConstants";

export const getLicenseData = async () => {
  try {
    return await axios.get(fabricLicense);
  } catch (e) {
    return createGenericErrorObject(e);
  }
};
